/* eslint-disable indent */
import { devices } from '@evidia/components';
import { Table } from 'antd';
import styled, { css } from 'styled-components';

export const StyledTable = styled(Table)<{ $disablePadding?: boolean }>`
	.ant-table-cell {
		padding: ${props => (props.$disablePadding ? '0' : '16px')} !important;
	}

	@media ${devices.tablet} {
		tr {
			display: flex;
			flex-direction: column;
		}
	}
`;

export const FooterActionButtons = styled.div`
	display: flex;
	gap: 1rem;

	@media ${devices.tablet} {
		flex-direction: column;
		width: 100%;
		padding: 0 0.5rem;

		div,
		button {
			margin-right: 0 !important;
		}
	}

	div {
		display: flex;
		flex-direction: row;

		button {
			margin: 0;
		}
		.ant-picker {
			padding: 0;
			margin: 0;
		}
	}
`;

export const FooterDiv = styled.div`
	display: flex;
	justify-content: space-between;
	padding-top: 1em;
`;

export const TableWrapper = styled.div<{ $border?: boolean; $tabletSmooth?: boolean }>`
	width: 100%;
	display: flex;
	flex-direction: column;

	thead {
		th {
			border-start-start-radius: 0 !important;
			border-start-end-radius: 0 !important;
			text-transform: uppercase;
			font-size: 12px;

			&:before {
				content: none !important;
			}
		}
	}

	tr:last-child {
		td {
			border-bottom: none;
		}
	}

	table {
		border: ${props => (props.$border ? '1px solid #fafafa' : undefined)};
		box-shadow: ${props => (props.$border ? '0px 1px 3px rgba(0, 0, 0, 0.1);' : '')};
	}

	@media ${devices.tablet} {
		${({ $tabletSmooth }) =>
			$tabletSmooth &&
			css`
				table {
					box-shadow: none;
					border-bottom: 1px solid #f0f0f0;
				}
			`}
	}
`;
